import type { ContestType } from '@betterpool/api-types/contests-service';

import type {
  FullContestPlayerOneAndDone,
  FullContestPlayerTiers,
} from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

import parseSlateBase from '../../common/context/SlatesContext/parseSlates/parseBaseSlate';
import getIsAfterPickDeadline from '../../common/context/SlatesContext/utils/getIsAfterPickDeadline';
import getPicksLabelBar from '../../common/utils/getMakePicksLabel';

type SlateWithStateAndSettingsPlayerTier = {
  id: string;
  contestType: ContestType.PLAYER_TIER | ContestType.PLAYER_ONE_AND_DONE;
  slate: ContestSlate;
  state: {
    isAfterPickDeadline: boolean;
    picksLabel?: string;
  };
  settings: {
    expectedPicksCount: number;
  };
};

const parsePlayerTierSlates = (
  contest: FullContestPlayerTiers | FullContestPlayerOneAndDone,
  slates: ContestSlate[]
): SlateWithStateAndSettingsPlayerTier[] =>
  slates.map((slate, index) => {
    const baseSlate = parseSlateBase(contest, slate, index);
    const isAfterPickDeadline = getIsAfterPickDeadline(contest, slate);

    return {
      ...baseSlate,
      contestType: contest.contest_type,
      state: {
        ...baseSlate.state,
        picksLabel:
          !isAfterPickDeadline && slate.isPicksheetAvailable
            ? getPicksLabelBar(contest, slate)
            : undefined,
      },
      settings: {
        expectedPicksCount:
          contest.tier_rules_settings.numberOfTiers * contest.tier_rules_settings.numberPerTier,
      },
    } satisfies SlateWithStateAndSettingsPlayerTier;
  });

export default parsePlayerTierSlates;

export type { SlateWithStateAndSettingsPlayerTier };
